<app-breadcrumb *ngIf="!disableBreadcrumbs" [master]="'Struktura sieci'" [parentName]="'Partnerzy'" [name]="'Dodaj'"></app-breadcrumb>
<div class="partners-add-container" [formGroup]="partnerForm" fxLayout="column" fxLayoutGap="15px">
  <div class="status-info" *ngIf="partnerObject">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + partnerObject.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="partnerObject.status?.name">
    </mat-form-field>
  </div>
<!--  <div class="status-gus-info" *ngIf="statusGus && !partnerObject">-->
<!--    <mat-form-field appearance="fill" [ngClass]="'input-color-' + statusGus.color">-->
<!--      <mat-label>Gus Status</mat-label>-->
<!--      <input matInput placeholder="GusStatus" [disabled]="true" [value]="statusGus?.name">-->
<!--    </mat-form-field>-->
<!--  </div>-->
<!--  <div class="status-gus-info-edit" *ngIf="partnerObject && partnerObject.gusStatus">-->
<!--    <mat-form-field appearance="fill" [ngClass]="'input-color-' + partnerObject.gusStatus?.color">-->
<!--      <mat-label>Gus Status</mat-label>-->
<!--      <input matInput placeholder="GusStatus" [disabled]="true" [value]="partnerObject.gusStatus?.name">-->
<!--    </mat-form-field>-->
<!--  </div>-->
<!--  <div class="status-gus-info-edit" *ngIf=" partnerObject && statusGus">-->
<!--    <mat-form-field appearance="fill" [ngClass]="'input-color-' + statusGus.color">-->
<!--      <mat-label>Gus Status</mat-label>-->
<!--      <input matInput placeholder="GusStatus" [disabled]="true" [value]="statusGus?.name">-->
<!--    </mat-form-field>-->
<!--  </div>-->
  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="sendForm()" [class.spinner]="processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <ng-container >
              <div fxLayout="row" >
                <h3 *ngIf="!hidePartner">Dane przedsiębiorstwa</h3>
                <h3 *ngIf="hidePartner">Dane osobowe</h3>
              </div>
<!--              <mat-radio-group formControlName="ofwcaPartner" *ngIf="hidePartner">-->
<!--                <div fxLayout="row" fxLayoutGap="15px"  class="formControlOfwca">-->
<!--                  <div fxFlex="50">-->
<!--                    <mat-radio-button value="0"  [checked]="partnerObject?.ofwcaPartner === false">Dane Przedsiębiorstwa </mat-radio-button>-->
<!--                  </div>-->
<!--                  <div fxFlex="50">-->
<!--                    <mat-radio-button value="1" [disabled]="radioOff" [checked]="partnerObject?.ofwcaPartner === true" >Dane OFWCA </mat-radio-button>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </mat-radio-group>-->
            </ng-container>
<!--            <ng-container *ngIf="!hidePartner">-->
            <ng-container>
              <div fxLayout="row" fxLayoutGap="15px" *ngIf="!formOfBusinessNonePartnership">
                <div fxFlex="100">
                  <mat-slide-toggle formControlName="foreignActivities" color="accent">Działalność zagraniczna</mat-slide-toggle>
                </div>
              </div>
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                  <mat-form-field class="partners-add-input" >
                    <mat-label>Pełna nazwa</mat-label>
                    <input appCapitalizeFirst matInput placeholder="Pełna nazwa" formControlName="fullName" [required]="true">
                    <mat-error *ngIf="partnerForm.get('fullName').hasError('required')">To pole jest wymagane</mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex="50">
                  <mat-form-field class="partners-add-input">
                    <mat-label>Skrócona nazwa</mat-label>
                    <input appCapitalizeFirst matInput placeholder="Skrócona nazwa" formControlName="shortName" [required]="true">
                    <mat-error *ngIf="partnerForm.get('shortName').hasError('required')">To pole jest wymagane</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                  <app-dict class="partners-add-input" [label]="'Forma prawna'" [dictType]="'legal_form'"
                            [control]="legalForm" [required]="true"></app-dict>
                </div>

                <div fxFlex="50" *ngIf="legalFormNatural">
                  <app-dict class="partners-add-input" [label]="'Typ działalności'" [dictType]="'form_of_business'"
                            [control]="formOfBusiness" [required]="true" [onlyKeys]="FORM_OF_BUSINESS_NATURAL_PERSON"></app-dict>
                </div>

                <div fxFlex="50" *ngIf="legalFormLegal">
                  <app-dict class="partners-add-input" [label]="'Typ działalności'" [dictType]="'form_of_business'"
                            [onlyKeys]="FORM_OF_BUSINESS_LEGAL_PERSON" [control]="formOfBusiness" [required]="true"></app-dict>
                </div>
              </div>
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="100" *ngIf="formOfBusinessNonePartnership">
                  <app-dict-ofwcas fxFlex="100" label="OFWCA" [control]="ofwca" [required]="formOfBusinessNonePartnership"  (selectedOfwca)=" ofwcaSelectUpdate($event)"></app-dict-ofwcas>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px" *ngIf="!partnerForm.get('foreignActivities').value && !formOfBusinessNonePartnership">
                <div fxFlex="42">
                  <mat-form-field class="partners-add-input">
                    <mat-label>NIP</mat-label>
                    <input matInput placeholder="NIP" formControlName="nip" [required]="true">
                    <mat-error *ngIf="partnerForm.get('nip').hasError('required')">To pole jest wymagane</mat-error>
                    <mat-error *ngIf="partnerForm.get('nip').hasError('invalidNip')">Podaj prawidłowy numer NIP</mat-error>
                    <mat-error *ngIf="partnerForm.get('nip').hasError('backendError')">{{errors.nip}}</mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex="5" >
                  <button *ngIf="partnerForm.get('nip').value" (click)="getGus()"  mat-icon-button color="primary" matTooltip="GUS"><mat-icon>send</mat-icon></button>
                </div>
                <div fxFlex="50">
                  <mat-form-field class="partners-add-input">
                    <mat-label>REGON</mat-label>
                    <input matInput placeholder="REGON" formControlName="regon" [required]="true">
                    <mat-error *ngIf="partnerForm.get('regon').hasError('required')">To pole jest wymagane</mat-error>
                    <mat-error *ngIf="partnerForm.get('regon').hasError('invalidRegon')">Podaj prawidłowy numer REGON</mat-error>
                    <mat-error *ngIf="partnerForm.get('regon').hasError('backendError')">{{errors.regon}}</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px" *ngIf="partnerForm.get('foreignActivities').value && !formOfBusinessNonePartnership">
                <div fxFlex="50">
                  <mat-form-field class="partners-add-input">
                    <mat-label>NIP</mat-label>
                    <input matInput placeholder="NIP" formControlName="foreignActivitiesNip" [required]="true">
                    </mat-form-field>
                </div>

                <div fxFlex="50">
                  <mat-form-field class="partners-add-input">
                    <mat-label>REGON</mat-label>
                    <input matInput placeholder="REGON" formControlName="foreignActivitiesRegon" [required]="true">
                    </mat-form-field>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px" >
                <div fxFlex="50" *ngIf="!formOfBusinessNonePartnership">
                  <mat-form-field class="partners-add-input">
                    <mat-label>Numer KRS</mat-label>
                    <input matInput placeholder="Numer KRS" [required]="requiredKrsNumber" formControlName="krs">
                    <mat-error *ngIf="partnerForm.get('krs').hasError('required')">To pole jest wymagane</mat-error>
                    <mat-error *ngIf="partnerForm.get('krs').hasError('backendError')">{{errors.krs}}</mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex="50">
                  <mat-form-field class="partners-add-input">
                    <mat-label>Numer rachunku bankowego</mat-label>
                    <input
                      prefix="PL" mask=" 00 0000 0000 0000 0000 0000 0000" [dropSpecialCharacters]="false"
                      matInput placeholder="PL 27 1140 2004 0000 3002 0135 5387" formControlName="accountNumber"
                    >
                    <mat-error *ngIf="partnerForm.get('accountNumber').hasError('invalidIban')">Podaj prawidłowy IBAN</mat-error>
                  </mat-form-field>
                </div>
              </div>



              <div fxLayout="row" fxLayoutGap="15px">
<!--                <div fxFlex="50">-->
<!--                  <mat-slide-toggle formControlName="vatPayer" color="accent"> Zarejestrowany jako płatnik VAT</mat-slide-toggle>-->
<!--                </div>-->

                <div fxFlex="50">
                  <mat-slide-toggle formControlName="newPartner" color="accent">Nowy Partner</mat-slide-toggle>
                </div>
                <div fxFlex="50">
                  <mat-slide-toggle formControlName="hasPkd" color="accent">PKD</mat-slide-toggle>
                </div>

              </div>

<!--              <div fxLayout="row" fxLayoutGap="15px">-->
<!--                <div fxFlex="50">-->
<!--                  <mat-slide-toggle formControlName="activeVatPayer" color="accent">Płatnik VAT czynny</mat-slide-toggle>-->
<!--                </div>-->

<!--              </div>-->

<!--              <div fxLayout="row" fxLayoutGap="15px">-->
<!--                <div fxFlex="100">-->
<!--                  <mat-slide-toggle formControlName="checkoutMethod" color="accent">Metoda kasowa</mat-slide-toggle>-->
<!--                </div>-->
<!--              </div>-->


<!--              <div fxLayout="row" fxLayoutGap="15px">-->
<!--                <div fxFlex="100">-->
<!--                  <mat-slide-toggle formControlName="selfBilling" color="accent">Samofakturowanie</mat-slide-toggle>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div fxLayout="row" *ngIf="partnerObject">-->
<!--                <div fxFlex="100">-->
<!--                  <mat-slide-toggle color="accent" formControlName="verified">Rekord zweryfikowany</mat-slide-toggle>-->
<!--                </div>-->
<!--              </div>-->
            </ng-container>
            <ng-container *ngIf="hidePartner">
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="100">
<!--                  <app-dict-ofwcas-->
<!--                    fxFlex="100"-->
<!--                    label="Wyszukiwarka OFWCA"-->
<!--                    [control]="ofwcaControl"-->
<!--                    [required]="false"-->
<!--                    (selectedOfwca)="ofwcaSelect($event)"-->
<!--                  ></app-dict-ofwcas>-->
                  <app-dict-all-contracts
                    fxFlex="100"
                    label="Wyszukiwarka OFWCA"
                    [required]="false"
                    [control]="ofwcaControl"
                    [filterPartnership]="true"
                    [showElements]="5"
                    (selectedContract)="contractChanged($event)"
                  ></app-dict-all-contracts>

                </div>
              </div>
              <div fxLayout="row">
                <app-dict-all-contracts
                  fxFlex="100" label="Umowa"
                  [control]="contractControl" [required]="false"
                  (selectedContract)="contractChanged($event)" [showOwnerName]="true"
                  [showStatus]="true" [filterRegistrationType]="true"
                ></app-dict-all-contracts>
              </div>
              <ng-container>
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                  <mat-form-field class="partners-add-input">
                    <mat-label>Imię</mat-label>
                    <input appCapitalizeFirst matInput placeholder="Imię"  [formControl]="ofwcaFirstName" [required]="true">
                    <mat-error *ngIf="partnerForm.get('ofwcaFirstName').hasError('required')">To pole jest wymagane</mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex="50">
                  <mat-form-field class="partners-add-input">
                    <mat-label>Drugie imię</mat-label>
                    <input appCapitalizeFirst matInput placeholder="Drugie imię" [required]="false" [formControl]="ofwcaSecondName">
                  </mat-form-field>
                </div>
              </div>
              </ng-container>
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                  <mat-form-field fxFlex="100">
                    <mat-label>Nazwisko</mat-label>
                    <input appCapitalizeFirst matInput placeholder="Nazwisko" formControlName="ofwcaLastName" [required]="true">
                    <mat-error *ngIf="partnerForm.get('ofwcaLastName').hasError('required')">To pole jest wymagane</mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex="50">
                  <mat-form-field fxFlex="100">
                    <mat-label>PESEL</mat-label>
                    <input matInput placeholder="PESEL" formControlName="ofwcaPesel" [required]="true">
                    <mat-error *ngIf="partnerForm.get('ofwcaPesel').hasError('required')">To pole jest wymagane</mat-error>
                    <mat-error *ngIf="partnerForm.get('ofwcaPesel').hasError('invalidPesel')">Podaj prawidłowy numer PESEL</mat-error>
                    <mat-error *ngIf="partnerForm.get('ofwcaPesel').hasError('backendError')">{{errors.pesel}}</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px">
                <span fxFlex="50"></span>
                <mat-slide-toggle fxFlex="50" color="accent" formControlName="withoutPesel">Brak PESEL</mat-slide-toggle>
              </div>

              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                  <mat-form-field fxFlex="100">
                    <mat-label>Nazwisko rodowe</mat-label>
                    <input appCapitalizeFirst matInput placeholder="Nazwisko rodowe" formControlName="ofwcaFamilyName" [required]="true">
                    <mat-error *ngIf="partnerForm.get('ofwcaFamilyName').hasError('required')">To pole jest wymagane</mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex="50">
                  <mat-form-field fxFlex="100">
                    <mat-label>Nazwisko panieńskie matki</mat-label>
                    <input appCapitalizeFirst matInput placeholder="Nazwisko panieńskie matki" formControlName="ofwcaMothersMaidenName" [required]="true">
                    <mat-error *ngIf="partnerForm.get('ofwcaMothersMaidenName').hasError('required')">To pole jest wymagane</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                  <mat-form-field fxFlex="100">
                    <mat-label>Imię matki</mat-label>
                    <input appCapitalizeFirst matInput placeholder="Imię matki" formControlName="ofwcaMothersName" [required]="true">
                    <mat-error *ngIf="partnerForm.get('ofwcaMothersName').hasError('required')">To pole jest wymagane</mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex="50">
                  <mat-form-field fxFlex="100">
                    <mat-label>Imię ojca</mat-label>
                    <input appCapitalizeFirst matInput placeholder="Imię ojca" formControlName="ofwcaFathersName" [required]="true">
                    <mat-error *ngIf="partnerForm.get('ofwcaFathersName').hasError('required')">To pole jest wymagane</mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                  <mat-form-field fxFlex="100">
                    <mat-label>Miejsce urodzenia</mat-label>
                    <input appCapitalizeFirst matInput placeholder="Warszawa" formControlName="ofwcaBirthPlace" [required]="true">
                    <mat-error *ngIf="partnerForm.get('ofwcaBirthPlace').hasError('required')">To pole jest wymagane</mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex="50">
                  <app-datepicker
                    label="Data urodzenia"
                    placeholder="2000-01-01"
                    [required]="true"
                    [control]="getControl('ofwcaBirthDate')"
                  ></app-datepicker>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                  <app-dict fxFlex="100" [label]="'Płeć'" [dictType]="'gender'"
                            [control]="getControl('ofwcaSex')" [required]="true"></app-dict>
                </div>

                <div fxFlex="50">
                  <app-dict fxFlex="100" [label]="'Wykształcenie'" [dictType]="'education'"
                            [control]="getControl('ofwcaEducation')" [required]="true"></app-dict>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px">
<!--                <div fxFlex="50" >-->
<!--                  <app-dict fxFlex="100" [label]="'OFWCA Status'" [dictType]="'ofwca_status'"-->
<!--                            [control]="getControl('ofwcaStatus')"></app-dict>-->

<!--                </div>-->
                <div fxFlex="50">
                  <mat-form-field fxFlex="100">
                    <mat-label>ofwcaContractId</mat-label>
                    <input appCapitalizeFirst matInput placeholder="ofwcaContractId" formControlName="ofwcaContractId">
                  </mat-form-field>
                </div>

                <div fxFlex="100">
                  <mat-form-field class="partners-add-input">
                    <mat-label>Numer rachunku bankowego</mat-label>
                    <input
                      prefix="PL" mask=" 00 0000 0000 0000 0000 0000 0000" [dropSpecialCharacters]="false"
                      matInput placeholder="PL 27 1140 2004 0000 3002 0135 5387" formControlName="accountNumber"
                    >
                    <mat-error *ngIf="partnerForm.get('accountNumber').hasError('invalidIban')">Podaj prawidłowy IBAN</mat-error>
                  </mat-form-field>
                </div>
              </div>


            </ng-container>
          </mat-card>
        </div>
      </div>
      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Relacje</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="33" *ngIf="!formOfBusinessNonePartnership">
                <app-dict-ofwcas fxFlex="100" label="Właściciel (OFWCA)" [control]="ofwca" [parent]="partnerUuid" [required]="formOfBusinessNonePartnership"  (selectedOfwca)=" ofwcaSelectUpdate($event)"></app-dict-ofwcas>
              </div>

              <div fxFlex="33">
                <app-dict-partners fxFlex="100" label="Partner nadrzędny" [control]="parentPartnerControl" [required]="false"></app-dict-partners>
              </div>

              <div fxFlex="33">
                <app-dict-partners fxFlex="100" label="Partner nadprowizja" [control]="overcommissionPartnerControl" [required]="false"></app-dict-partners>
              </div>
            </div>

            <div  *ngIf="formOfBusinessNonePartnership && ofwcaSelect">
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                <app-detail header="PESEL" [value]="ofwcaSelect.pesel"  [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
                </div>
                <div fxFlex="50">
                <app-detail header="Drugie imię" [value]="ofwcaSelect.secondName"></app-detail>
                </div>
              </div>
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                <app-detail header="Nazwisko rodowe" [value]="ofwcaSelect.familyName"  [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
                </div>
                <div fxFlex="50">
                <app-detail header="Nazwisko panieńskie matki" [value]="ofwcaSelect.mothersMaidenName"  [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
                </div>
              </div>
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                <app-detail header="Imię matki" [value]="ofwcaSelect.mothersName"  [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
                </div>

                <div fxFlex="50">
                <app-detail header="Imię ojca" [value]="ofwcaSelect.fathersName"  [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
                </div>
              </div>
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                <app-detail header="Miejsce urodzenia" [value]="ofwcaSelect.birthPlace"  [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
                </div>

                <div fxFlex="50">
                <app-detail header="Data urodzenia" [value]="ofwcaSelect.birthDate | date:'y-MM-dd'"  [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
                </div>
              </div>
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                <app-detail header="Płeć" [value]="ofwcaSelect.sex.name"></app-detail>
                </div>

                <div fxFlex="50">
                <app-detail header="Wykształcenie" [value]="ofwcaSelect.education?.name"  [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
                </div>
              </div>
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="100">
                <app-detail header="Obywatelstwo" [value]="ofwcaSelect.citizenship"></app-detail>
                </div>
              </div>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <mat-form-field fxFlex="100">
                  <mat-label>Numer Profitowi</mat-label>
                  <input appCapitalizeFirst matInput placeholder="Numer Profitowi" formControlName="profitNumber" [required]="false">
                </mat-form-field>
              </div>
            </div>

          </mat-card>
        </div>
      </div>


      <div *ngIf="!hideRepresentation" fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card class="partners-add-card" fxLayout="column">
            <div fxLayout="row">
              <h3>
                Reprezentacja
              </h3>
            </div>

            <div fxLayout="column" fxFlex="100" *ngFor="let formGroup of representationFormArray; index as i">
              <div fxLayout="row" fxLayoutGap="15px" [formGroup]="formGroup">
                <div fxFlex="5" class="list-counter">
                  {{i+1}}.
                </div>

                <div fxFlex="90" fxLayoutGap="10px">
                  <div fxFlex="34" >
                    <mat-form-field class="partners-add-input">
                      <mat-label>Imię</mat-label>
                      <input appCapitalizeFirst matInput placeholder="Imię" formControlName="firstName">
                      <mat-error *ngIf="formGroup.get('firstName').hasError('required')">To pole jest wymagane</mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex="34" >
                    <mat-form-field class="partners-add-input">
                      <mat-label>Nazwisko</mat-label>
                      <input appCapitalizeFirst matInput placeholder="Nazwisko" formControlName="lastName" [required]="true">
                      <mat-error *ngIf="formGroup.get('lastName').hasError('required')">To pole jest wymagane</mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex="34" >
                    <app-dynamic-dict
                      fxFlex="100"
                      label="Funkcja"
                      [required]="false"
                      [control]="$any(formGroup.get('functionPartner'))"
                      [dictType]="DYNAMIC_DICTIONARY_FUNCTION"
                      [returnObject]="true">
                    </app-dynamic-dict>
                  </div>
                </div>

                <div fxFlex="5"  fxLayoutGap="15px">
                  <div class="list-remove-button">
                    <button (click)="removeRepresentation(i)" mat-icon-button color="warn">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>

              </div>

            </div>

            <div fxFlex="100" fxLayout="row">
              <span fxFlex="">
                  <mat-error *ngIf="partnerForm.get('representation').hasError('minLength')">Musisz podać przynajmniej jednego reprezentanta</mat-error>
              </span>
              <button (click)="addRepresentation()" mat-stroked-button color="primary">
                <mat-icon>add_box</mat-icon> <span> Dodaj</span>
              </button>
            </div>
          </mat-card>

        </div>

      </div>


      <div *ngIf="hideBusinessEntities" fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card class="partners-add-card" fxLayout="column">
            <div fxLayout="row">
              <h3>
                Podmioty działające w ramach spółki
              </h3>
            </div>

            <div fxLayout="column" fxFlex="100" *ngFor="let formGroup of businessEntitiesFormArray; index as i">
              <div fxLayout="row" fxLayoutGap="15px" [formGroup]="formGroup">
                <div fxFlex="2" class="list-counter">
                  {{i+1}}.
                </div>

                <div fxFlex="98" fxLayoutGap="10px">
                  <div fxFlex="95.5" >
                    <mat-form-field class="partners-add-input">
                      <mat-label>Pełna nazwa działalności</mat-label>
                      <input appCapitalizeFirst matInput placeholder="Pełna nazwa działalności" formControlName="businessFullName">
                      <mat-error *ngIf="formGroup.get('businessFullName').hasError('required')">To pole jest wymagane</mat-error>
                    </mat-form-field>
                  </div>

                </div>

              </div>
              <div fxLayout="row" fxLayoutGap="15px"  [formGroup]="formGroup">
                  <div fxFlex="2" class="list-counter">
                  </div>
                <div fxFlex="98" fxLayoutGap="10px">
                  <div fxFlex="47" >
                    <mat-form-field class="partners-add-input">
                      <mat-label>Imię</mat-label>
                      <input appCapitalizeFirst matInput placeholder="Imię" formControlName="businessFirstName">
                      <mat-error *ngIf="formGroup.get('businessFirstName').hasError('required')">To pole jest wymagane</mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex="47" >
                    <mat-form-field class="partners-add-input">
                      <mat-label>Nazwisko</mat-label>
                      <input appCapitalizeFirst matInput placeholder="Nazwisko" formControlName="businessLastName">
                      <mat-error *ngIf="formGroup.get('businessLastName').hasError('required')">To pole jest wymagane</mat-error>
                    </mat-form-field>
                  </div>

                </div>
              </div>
              <div fxLayout="row" fxLayoutGap="15px"  [formGroup]="formGroup">
                <div fxFlex="2" class="list-counter">
                </div>
                <div fxFlex="98" fxLayoutGap="10px">
                  <div fxFlex="47" >
                    <mat-form-field class="partners-add-input">
                      <mat-label>NIP</mat-label>
                      <input appCapitalizeFirst matInput placeholder="NIP" formControlName="businessNip">
                      <mat-error *ngIf="formGroup.get('businessNip').hasError('required')">To pole jest wymagane</mat-error>
                      <mat-error *ngIf="formGroup.get('businessNip').hasError('invalidNip')">Podaj prawidłowy numer NIP</mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex="47" >
                    <mat-form-field class="partners-add-input">
                      <mat-label>REGON</mat-label>
                      <input appCapitalizeFirst matInput placeholder="REGON" formControlName="businessRegon">
                      <mat-error *ngIf="formGroup.get('businessRegon').hasError('required')">To pole jest wymagane</mat-error>
                      <mat-error *ngIf="formGroup.get('businessRegon').hasError('invalidRegon')">Podaj prawidłowy numer REGON</mat-error>
                    </mat-form-field>
                  </div>

                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px"  [formGroup]="formGroup">
                <div fxFlex="2" class="list-counter">
                </div>
                <div fxFlex="98" fxLayoutGap="10px">
                  <div fxFlex="47" >
                    <mat-form-field class="partners-add-input">
                      <mat-label>Nr telefonu</mat-label>
                      <input appCapitalizeFirst matInput placeholder="Nr telefonu" formControlName="businessPhone"  prefix="+48" mask=" 000 000 000">
                      <mat-error *ngIf="formGroup.get('businessPhone').hasError('required')">To pole jest wymagane</mat-error>
                      <mat-error *ngIf="formGroup.get('businessPhone').hasError('invalidPhoneNumber')">Podaj poprawny numer telefonu</mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex="47" >
                    <mat-form-field class="partners-add-input">
                      <mat-label>Adres mailowy</mat-label>
                      <input appCapitalizeFirst matInput placeholder="Adres mailowy" formControlName="businessEmail">
                      <mat-error *ngIf="formGroup.get('businessEmail').hasError('required')">To pole jest wymagane</mat-error>
                      <mat-error *ngIf="formGroup.get('businessEmail').hasError('email')">Podaj poprawny adres email</mat-error>
                    </mat-form-field>
                  </div>

                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px"  [formGroup]="formGroup">
                <div fxFlex="2" class="list-counter">
                </div>
                <div fxFlex="90" fxLayoutGap="10px">
                  <div fxFlex="50" >
                    <mat-form-field class="partners-add-input">
                      <mat-label>Ulica</mat-label>
                      <input appCapitalizeFirst matInput placeholder="Ulica" formControlName="businessStreet">
                      <mat-error *ngIf="formGroup.get('businessStreet').hasError('required')">To pole jest wymagane</mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex="24" >
                    <mat-form-field class="partners-add-input">
                      <mat-label>Nr budynku</mat-label>
                      <input appCapitalizeFirst matInput placeholder="Nr budynku" formControlName="businessHouseNumber">
                      <mat-error *ngIf="formGroup.get('businessHouseNumber').hasError('required')">To pole jest wymagane</mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex="24" >
                    <mat-form-field class="partners-add-input">
                      <mat-label>Nr mieszkania</mat-label>
                      <input appCapitalizeFirst matInput placeholder="Nr mieszkania" formControlName="businessApartmentNumber">
                    </mat-form-field>
                  </div>

                </div>

                <div fxFlex="5"  fxLayoutGap="15px">
                  <div class="list-remove-button">
                    <button (click)="removeBusinessEntities(i)" mat-icon-button color="warn">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              </div>


              <div fxLayout="row" fxLayoutGap="15px"  [formGroup]="formGroup">
                <div fxFlex="2" class="list-counter">
                </div>
                <div fxFlex="98" fxLayoutGap="10px">
                  <div fxFlex="47" >
                    <mat-form-field class="partners-add-input">
                      <mat-label>Miejscowość</mat-label>
                      <input appCapitalizeFirst matInput placeholder="Miejscowość" formControlName="businessCity">
                      <mat-error *ngIf="formGroup.get('businessCity').hasError('required')">To pole jest wymagane</mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex="47" >
                    <mat-form-field class="partners-add-input">
                      <mat-label>Kod pocztowy</mat-label>
                      <input appCapitalizeFirst matInput placeholder="Kod pocztowy" formControlName="businessZipCode" mask="99-999" [showMaskTyped]="true" [dropSpecialCharacters]="false">
                      <mat-error *ngIf="formGroup.get('businessZipCode').hasError('required')">To pole jest wymagane</mat-error>
                    </mat-form-field>
                  </div>

                </div>
              </div>
              <div fxLayout="row" fxLayoutGap="15px"  [formGroup]="formGroup">
                <div fxFlex="2" class="list-counter">
                </div>
                <div fxFlex="98" fxLayoutGap="10px">
                  <div fxFlex="47" >
                    <app-dict class="partners-add-input" [label]="'Województwo'" [dictType]="'address_state'" formControlName="businessState" ></app-dict>
                  </div>
                  <div fxFlex="47" >
                    <mat-form-field class="partners-add-input">
                      <mat-label>Poczta</mat-label>
                      <input appCapitalizeFirst matInput placeholder="Poczta" formControlName="businessPostCity">
                      <mat-error *ngIf="formGroup.get('businessPostCity').hasError('required')">To pole jest wymagane</mat-error>
                    </mat-form-field>
                  </div>

                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px"  [formGroup]="formGroup">
                <div fxFlex="2" class="list-counter">
                </div>
                <div fxFlex="98" fxLayoutGap="10px">
                  <div fxFlex="47" >
                    <mat-form-field class="partners-add-input">
                      <mat-label>Powiat</mat-label>
                      <input appCapitalizeFirst matInput placeholder="Powiat" formControlName="businessDistrict">
                      <mat-error *ngIf="formGroup.get('businessDistrict').hasError('required')">To pole jest wymagane</mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex="47" >
                    <mat-form-field class="partners-add-input">
                      <mat-label>Gmina</mat-label>
                      <input appCapitalizeFirst matInput placeholder="Gmina" formControlName="businessCommune">
                      <mat-error *ngIf="formGroup.get('businessCommune').hasError('required')">To pole jest wymagane</mat-error>
                    </mat-form-field>
                  </div>

                </div>
              </div>


            </div>

            <div fxFlex="100" fxLayout="row">
              <span fxFlex="">
                  <mat-error *ngIf="partnerForm.get('businessEntities').hasError('minLength')">Musisz podać przynajmniej dwa podmioty działające w ramach spółki</mat-error>
              </span>
              <button (click)="addBusinessEntities()" mat-stroked-button color="primary">
                <mat-icon>add_box</mat-icon> <span> Dodaj</span>
              </button>
            </div>
          </mat-card>

        </div>

      </div>


      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card class="partners-add-card" fxLayout="column">

            <div fxLayout="row">
              <h3>Kontakt email</h3>
            </div>


            <div fxLayout="row" fxLayoutGap="15px">
              <h5 fxFlex>Adres email główny</h5>

            </div>

            <div fxLayout="row" *ngIf="mainEmails.length === 0">
              <mat-error>Musisz podać przynajmniej jeden adres główny</mat-error>
            </div>

            <div fxLayout="row" *ngIf="partnerForm.hasError('atLeastOneRequired')">
              <mat-error>
                Co najmniej jeden adres e-mail musi zostać oznaczony jako rozliczeniowy oraz leadowy.
              </mat-error>
            </div>
            <div fxLayout="column" fxFlex="100">
              <ng-container *ngFor="let formGroup of mainEmails; index as i">
                <div fxLayout="column" [formGroup]="formGroup" class="separator">

                  <!-- EMAIL + NAZWA -->
                  <div fxLayout="row" fxLayoutGap="15px">
                    <input type="hidden" formControlName="uuid">

                    <div fxFlex="50">
                      <div fxFlex="6" class="list-counter">
                        {{i + 1}}.
                      </div>
                      <div fxFlex="94">
                        <mat-form-field class="partners-add-input">
                          <mat-label>Adres</mat-label>
                          <input matInput placeholder="adres@asf.com.pl" formControlName="email" [required]="true">
                          <mat-error *ngIf="formGroup.get('email').hasError('required')">To pole jest wymagane</mat-error>
                          <mat-error *ngIf="formGroup.get('email').hasError('email')">Podaj poprawny adres email</mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div fxFlex="50" fxLayoutGap="15px">
                      <div fxFlex="90">
                        <mat-form-field class="partners-add-input">
                          <mat-label>Nazwa</mat-label>
                          <input matInput formControlName="name">
                        </mat-form-field>
                      </div>

                      <div fxFlex="10" class="list-remove-button">
                        <button (click)="removeEmail(i, 'mainEmails')" mat-icon-button color="warn"
                                *ngIf="mainEmails.length > 1">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>

<!--                  <div class="registration-details" fxFlex>-->
<!--                    <h3 style="margin-bottom: 0;">Jakie wiadomości wysyłać na ten adres email?</h3>-->
<!--                    <div>Zaznacz wszystkie rodzaje wiadomości, króre mają trafić na ten adres e-mail.</div>-->
<!--                  </div>-->

                  <div fxLayout="row">
                    <h4 class="structure-title">Jakie wiadomości wysyłać na ten adres email?</h4>
                  </div>
                  <div fxLayout="row">
                    <p class="structure-description">Zaznacz wszystkie rodzaje wiadomości, króre mają trafić na ten adres e-mail.</p>
                  </div>

                  <!-- ZGODY -->
                  <div fxLayout="row" fxLayoutGap="20px" class="consents">
                    <mat-slide-toggle formControlName="marketing" fxFlex="25" >
                      Marketingowe
                    </mat-slide-toggle>

                    <mat-slide-toggle formControlName="product" fxFlex="25">
                      Produktowe
                    </mat-slide-toggle>

                    <mat-slide-toggle formControlName="billing" fxFlex="25">
                      Rozliczeniowe
                    </mat-slide-toggle>
                    <mat-slide-toggle formControlName="lead" fxFlex="25">
                      Lead'owe
                    </mat-slide-toggle>
                  </div>

                </div>
              </ng-container>
            </div>

            <div class="add-button">
              <button class="small-button" (click)="addEmail('mainEmails')"  mat-raised-button color="accent" >
                <mat-icon>add</mat-icon> <span> Dodaj</span>
              </button>
            </div>


            <div fxLayout="row" fxLayoutGap="15px">
              <h5 fxFlex>Adresy email dodatkowe</h5>
<!--              <div class="list-add-button">-->
<!--                <button (click)="addEmail('additionalEmails')" mat-icon-button color="primary">-->
<!--                  <mat-icon>add_box</mat-icon>-->
<!--                </button>-->
<!--              </div>-->
            </div>

            <div fxLayout="column" fxFlex="100">
              <ng-container *ngFor="let formGroup of additionalEmails; index as i">
                <div fxLayout="column" [formGroup]="formGroup" class="separator">

                  <div fxLayout="row" fxLayoutGap="15px">
                    <input type="hidden" formControlName="uuid">

                    <div fxFlex="50">
                      <div fxFlex="6" class="list-counter">
                        {{i + 1}}.
                      </div>
                      <div fxFlex="94">
                        <mat-form-field class="partners-add-input">
                          <mat-label>Adres</mat-label>
                          <input matInput placeholder="adres@asf.com.pl" formControlName="email" [required]="true">
                          <mat-error *ngIf="formGroup.get('email').hasError('email')">Podaj poprawny adres email</mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div fxFlex="50" fxLayoutGap="15px">
                      <div fxFlex="90">
                        <mat-form-field class="partners-add-input">
                          <mat-label>Nazwa</mat-label>
                          <input matInput formControlName="name">
                        </mat-form-field>
                      </div>

                      <div fxFlex="10" class="list-remove-button">
                        <button (click)="removeEmail(i, 'additionalEmails')" mat-icon-button color="warn">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>

<!--                  <div class="registration-details" fxFlex>-->
<!--                    <h3 style="margin-bottom: 0;">Jakie wiadomości wysyłać na ten adres email?</h3>-->
<!--                    <div>Zaznacz wszystkie rodzaje wiadomości, króre mają trafić na ten adres e-mail.</div>-->
<!--                  </div>-->

                  <div fxLayout="row">
                    <h4 class="structure-title">Jakie wiadomości wysyłać na ten adres email?</h4>
                  </div>
                  <div fxLayout="row">
                    <p class="structure-description">Zaznacz wszystkie rodzaje wiadomości, króre mają trafić na ten adres e-mail.</p>
                  </div>

                  <div fxLayout="row" fxLayoutGap="20px" class="consents">
                    <mat-slide-toggle formControlName="marketing"  fxFlex="25">
                      Marketingowe
                    </mat-slide-toggle>

                    <mat-slide-toggle formControlName="product" fxFlex="25">
                      Produktowe
                    </mat-slide-toggle>

                    <mat-slide-toggle formControlName="billing" fxFlex="25">
                      Rozliczeniowe
                    </mat-slide-toggle>
                    <mat-slide-toggle formControlName="lead" fxFlex="25">
                      Lead'owe
                    </mat-slide-toggle>
                  </div>

                </div>
              </ng-container>
            </div>


            <div class="add-button">
              <button class="small-button" (click)="addEmail('additionalEmails')"  mat-raised-button color="accent" >
                <mat-icon>add</mat-icon> <span> Dodaj</span>
              </button>
            </div>


          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card class="partners-add-card" fxLayout="column">

            <div fxLayout="row">
              <h3>Kontakt telefoniczny</h3>
            </div>


            <div fxLayout="row" fxLayoutGap="15px">
              <h5 fxFlex>Numer telefonu główny</h5>
            </div>

            <div fxLayout="row" *ngIf="mainPhones.length === 0">
              <mat-error>Musisz podać przynajmniej jeden numer główny</mat-error>
            </div>

            <div fxLayout="column" fxFlex="100">
              <ng-container *ngFor="let formGroup of mainPhones; index as i">
                <div fxLayout="column" [formGroup]="formGroup" class="separator">

                  <div fxLayout="row" fxLayoutGap="15px">
                    <input type="hidden" formControlName="uuid">

                    <div fxFlex="50">
                      <div fxFlex="6" class="list-counter">
                        {{i + 1}}.
                      </div>
                      <div fxFlex="94">
                        <mat-form-field class="partners-add-input">
                          <mat-label>Numer</mat-label>
                          <input matInput placeholder="+48 500 200 300" formControlName="phone" [required]="true" prefix="+48" mask=" 000 000 000">
                          <mat-error *ngIf="formGroup.get('phone').hasError('required')">To pole jest wymagane</mat-error>
                          <mat-error *ngIf="formGroup.get('phone').hasError('invalidPhoneNumber')">Podaj poprawny numer telefonu</mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div fxFlex="50" fxLayoutGap="15px">
                      <div fxFlex="90">
                        <mat-form-field class="partners-add-input">
                          <mat-label>Nazwa</mat-label>
                          <input matInput formControlName="name">
                        </mat-form-field>
                      </div>

                      <div fxFlex="10" class="list-remove-button">
                        <button (click)="removePhone(i, 'mainPhones')" mat-icon-button color="warn"
                                *ngIf="mainPhones.length > 1">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>

<!--                  <div class="registration-details" fxFlex>-->
<!--                    <h3 style="margin-bottom: 0;">Jakie wiadomości wysyłać na ten numer telefonu?</h3>-->
<!--                    <div>Zaznacz wszystkie rodzaje wiadomości, króre mają trafić na ten numer telefonu.</div>-->
<!--                  </div>-->


                  <div fxLayout="row">
                    <h4 class="structure-title">Jakie wiadomości wysyłać na ten numer telefonu?</h4>
                  </div>
                  <div fxLayout="row">
                    <p class="structure-description">Zaznacz wszystkie rodzaje wiadomości, króre mają trafić na ten numer telefonu.</p>
                  </div>
                  <!-- ZGODY -->
                  <div fxLayout="row" fxLayoutGap="20px" class="consents">
                    <mat-slide-toggle formControlName="marketing" fxFlex="33" >
                      Marketingowe
                    </mat-slide-toggle>

                    <mat-slide-toggle formControlName="product" fxFlex="33">
                      Produktowe
                    </mat-slide-toggle>

                    <mat-slide-toggle formControlName="billing" fxFlex="33">
                      Rozliczeniowe
                    </mat-slide-toggle>
                  </div>

                </div>
              </ng-container>
            </div>

            <div class="add-button">
              <button class="small-button" (click)="addPhone('mainPhones')"  mat-raised-button color="accent" >
                <mat-icon>add</mat-icon> <span> Dodaj</span>
              </button>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <h5 fxFlex>Numer telefonu dodatkowe</h5>
<!--              <div class="list-add-button">-->
<!--                <button (click)="addPhone('additionalPhones')" mat-icon-button color="primary">-->
<!--                  <mat-icon>add_box</mat-icon>-->
<!--                </button>-->
<!--              </div>-->
            </div>

            <div fxLayout="column" fxFlex="100">
              <ng-container *ngFor="let formGroup of additionalPhones; index as i">
                <div fxLayout="column" [formGroup]="formGroup" class="separator">

                  <div fxLayout="row" fxLayoutGap="15px">
                    <input type="hidden" formControlName="uuid">

                    <div fxFlex="50">
                      <div fxFlex="6" class="list-counter">
                        {{i + 1}}.
                      </div>
                      <mat-form-field class="partners-add-input">
                        <mat-label>Numer</mat-label>
                        <input matInput placeholder="+48 500 200 300" formControlName="phone" [required]="true" prefix="+48" mask=" 000 000 000">
                        <mat-error *ngIf="formGroup.get('phone').hasError('required')">To pole jest wymagane</mat-error>
                        <mat-error *ngIf="formGroup.get('phone').hasError('invalidPhoneNumber')">Podaj poprawny numer telefonu</mat-error>
                      </mat-form-field>
                    </div>

                    <div fxFlex="50" fxLayoutGap="15px">
                      <div fxFlex="90">
                        <mat-form-field class="partners-add-input">
                          <mat-label>Nazwa</mat-label>
                          <input matInput formControlName="name">
                        </mat-form-field>
                      </div>

                      <div fxFlex="10" class="list-remove-button">
                        <button (click)="removePhone(i, 'additionalPhones')" mat-icon-button color="warn">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>


<!--                  <div class="registration-details" fxFlex>-->
<!--                    <h3 style="margin-bottom: 0;">Jakie wiadomości wysyłać na ten numer telefonu?</h3>-->
<!--                    <div>Zaznacz wszystkie rodzaje wiadomości, króre mają trafić na ten numer telefonu.</div>-->
<!--                  </div>-->

                  <div fxLayout="row">
                    <h4 class="structure-title">Jakie wiadomości wysyłać na ten numer telefonu?</h4>
                  </div>
                  <div fxLayout="row">
                    <p class="structure-description">Zaznacz wszystkie rodzaje wiadomości, króre mają trafić na ten numer telefonu.</p>
                  </div>

                  <div fxLayout="row" fxLayoutGap="20px" class="consents">
                    <mat-slide-toggle formControlName="marketing"  fxFlex="33">
                      Marketingowe
                    </mat-slide-toggle>

                    <mat-slide-toggle formControlName="product" fxFlex="33">
                      Produktowe
                    </mat-slide-toggle>

                    <mat-slide-toggle formControlName="billing" fxFlex="33">
                      Rozliczeniowe
                    </mat-slide-toggle>
                  </div>

                </div>
              </ng-container>
            </div>

            <div class="add-button">
              <button class="small-button" (click)="addPhone('additionalPhones')"  mat-raised-button color="accent" >
                <mat-icon>add</mat-icon> <span> Dodaj</span>
              </button>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Konto ASF360</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="partnerObject?.user360?.length > 0">
              <div fxFlex="100">
                <ng-container *ngFor="let user of partnerObject.user360; let i = index">
                  <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around center">

                    <button
                      fxFlex="35"
                      mat-raised-button
                      [ngClass]="user.active ? 'positive-button' : 'negative-button'"
                    >
                      {{ user.active ? 'Konto aktywne' : 'Konto nieaktywne' }}
                    </button>

                    <app-detail fxFlex="65" header="Login">{{ user.username }}</app-detail>

                  </div>
                </ng-container>
              </div>
            </div>
            <div fxLayout="row">
              <h4 class="structure-title">Treści na tablicy Partnera</h4>
            </div>
            <div fxLayout="row">
              <p class="structure-description">Wybierz rodzaje treści, które będą wyświetlane na tablicy partnera po zalogowaniu do ASF360</p>
            </div>


            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <mat-slide-toggle formControlName="productMessageConsent" color="accent">Aktualności produktowe</mat-slide-toggle>
              </div>
              <div fxFlex="50">
                <mat-slide-toggle formControlName="contestMessageConsent" color="accent">Aktualności marketingowe</mat-slide-toggle>
              </div>
            </div>

<!--            <div fxLayout="row" fxLayoutGap="15px">-->
<!--              <div fxFlex="50">-->
<!--                <app-detail-bool header="Aktualności produktowe"-->
<!--                                 [value]="partnerObject.productMessageConsent"></app-detail-bool>-->
<!--              </div>-->
<!--              <div fxFlex="50">-->
<!--                <app-detail-bool header="Aktualności marketingowe"-->
<!--                                 [value]="partnerObject.contestMessageConsent"></app-detail-bool>-->
<!--              </div>-->
<!--            </div>-->

          </mat-card>
        </div>
      </div>


    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <app-address-form *ngIf="!partnerForm.get('foreignActivities').value" [title]="'Adres siedziby'" [addressForm]="headquartersAddress" [required]="true"></app-address-form>
      <app-address-form *ngIf="partnerForm.get('foreignActivities').value" [title]="'Adres siedziby'" [addressForm]="foreignActivitiesHeadquartersAddress" [required]="true" [foreignActivitiesType] ="true"></app-address-form>
      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <mat-slide-toggle color="accent" formControlName="communicationAddressSameAsHeadquarters">Adres korespondencyjny taki sam jak siedziby</mat-slide-toggle>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <app-address-form *ngIf="this.communicationAddress.enabled" [title]="'Adres korespondencyjny'" [addressForm]="communicationAddress"></app-address-form>

      <div fxLayout="row" fxFlex.lt-md="100" *ngIf='(userPermissions | async).settlement.delete'>
        <div fxFlex="100" >
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Blokady rozliczeń </h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <mat-slide-toggle formControlName="settlementSendBlockAsf" color="accent">Blokada wysyłki rozliczenia ASF</mat-slide-toggle>
              </div>
              <div fxFlex="50">
                <mat-slide-toggle formControlName="settlementSendBlockPremium" color="accent">Blokada wysyłki rozliczenia ASF Premium</mat-slide-toggle>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <mat-slide-toggle formControlName="invoiceGenerateBlockAsf" color="accent">Blokada generowania faktur ASF</mat-slide-toggle>
              </div>
              <div fxFlex="50">
                <mat-slide-toggle formControlName="invoiceGenerateBlockPremium" color="accent">Blokada generowania faktur ASF Premium</mat-slide-toggle>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <mat-slide-toggle formControlName="invoiceAddBlockAsf" color="accent">Blokada komornicza ASF</mat-slide-toggle>
              </div>
              <div fxFlex="50">
                <mat-slide-toggle formControlName="invoiceAddBlockPremium" color="accent">Blokada komornicza ASF Premium</mat-slide-toggle>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <ng-container *ngIf="!hidePartner && partnerObject">
        <div fxLayout="row" fxFlex.lt-md="100%">
          <div fxFlex="100">
            <mat-card class="partners-add-card" >
              <div fxLayout="row">
                <h3>Hiperio</h3>
              </div>

              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                  <mat-form-field fxFlex="100">
                    <mat-label>Login</mat-label>
                    <input appCapitalizeFirst matInput placeholder="Login" formControlName="hiperioLogin" [required]="false">
                  </mat-form-field>
                </div>

                <div fxFlex="50">
                  <mat-form-field fxFlex="100">
                    <mat-label>Email</mat-label>
                    <input appCapitalizeFirst matInput placeholder="Email" formControlName="hiperioEmail" [required]="false">
                  </mat-form-field>
                </div>
              </div>

            </mat-card>
          </div>
        </div>
      </ng-container>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="partnerObject">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Tagi</h3>
            </div>

            <div fxLayout="row">
              <div fxFlex="100">
                <app-dict class="partners-add-input" [label]="'Tagi'" [dictType]="'partner_tags'" [skipKeys]="this.AUTOMATIC_TAGS"
                          formControlName="tags" [control]="tags" [required]="false" [multiple]="true"></app-dict>
              </div>
            </div>

          </mat-card>
        </div>
      </div>


<!--      <div fxLayout="row" fxFlex.lt-md="100%">-->
<!--        <div fxFlex="100">-->
<!--          <mat-card class="partners-add-card">-->
<!--            <div fxLayout="row">-->
<!--              <h3>Zgody</h3>-->
<!--            </div>-->

<!--            <div fxLayout="row" fxLayoutGap="15px">-->
<!--              <div fxFlex="50">-->
<!--                <mat-slide-toggle formControlName="productMessageConsent" color="accent">Aktualności produktowe</mat-slide-toggle>-->
<!--              </div>-->

<!--              <div fxFlex="50">-->
<!--                <mat-slide-toggle formControlName="contestMessageConsent" color="accent">Aktualności marketingowe</mat-slide-toggle>-->
<!--              </div>-->
<!--            </div>-->


<!--          </mat-card>-->
<!--        </div>-->
<!--      </div>-->

      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Uwagi</h3>
            </div>

            <div fxLayout="row">
              <mat-form-field fxFlex="100">
                <mat-label>Uwagi</mat-label>
                <textarea formControlName="note" matInput placeholder="Uwagi"></textarea>
              </mat-form-field>
            </div>

          </mat-card>
        </div>
      </div>

    </div>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="sendForm()" [class.spinner]="processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
